import service from './axios';

// 获取预约商品列表
export const fetchAppointmentProductsList = (params) => {
  return service({
    method: 'get',
    url: '/manage/appointment-products',
    params
  });
};

// 获取预约商品详情
export const fetchAppointmentProductDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/appointment-products/${id}`
  });
};

// 创建预约商品
export const createAppointmentProduct = (data) => {
  return service({
    method: 'post',
    url: '/manage/appointment-products',
    data
  });
};

// 更新预约商品
export const updateAppointmentProduct = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/appointment-products/${id}`,
    data
  });
};

// 删除预约商品
export const deleteAppointmentProduct = (id) => {
  return service({
    method: 'delete',
    url: `/manage/appointment-products/${id}`
  });
};

// 更新预约商品状态
export const updateAppointmentProductStatus = (id, status) => {
  return service({
    method: 'patch',
    url: `/manage/appointment-products/${id}/status`,
    data: { status }
  });
};

// 获取预约记录
export const fetchAppointmentRecords = (productId, params) => {
  return service({
    method: 'get',
    url: `/manage/appointment-products/${productId}/records`,
    params
  });
};

// 确认预约记录
export const confirmAppointmentRecord = (recordId) => {
  return service({
    method: 'post',
    url: `/manage/appointment-products/records/${recordId}/confirm`
  });
};

// 取消预约记录
export const cancelAppointmentRecord = (recordId) => {
  return service({
    method: 'post',
    url: `/manage/appointment-products/records/${recordId}/cancel`
  });
};

// 获取所有预约记录
export const fetchAllAppointmentRecords = (params) => {
  return service({
    method: 'get',
    url: '/manage/appointment-products/records/all',
    params
  });
};

// 导出预约记录列表
export const exportAppointmentRecords = (params) => {
  return service({
    method: 'post',
    url: '/manage/appointment-products/records/export',
    data: params
  });
};
